// extracted by mini-css-extract-plugin
export default {"container":"Zp-z","heading":"_p-z","text":"aq-z","info":"bq-z","link":"cq-z","fullMaxWidth":"dq-z"};